import { render, staticRenderFns } from "./GrapeFarmer.vue?vue&type=template&id=e2248bf8&"
import script from "./GrapeFarmer.vue?vue&type=script&lang=js&"
export * from "./GrapeFarmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports